/**
 * @version
 */
export const AUI_VERSION = '1.6.0-beta.4';
